import 'waypoints/lib/noframework.waypoints.js';

(($) => {
  $(() => {
    const $imageScrollers = $('.section--image-scroller');

    if ($imageScrollers.length) {
      const $scrollable = $('html, body');

      const updateSticky = ($sticky, fixed, bottom) => {
        $sticky[fixed ? 'addClass' : 'removeClass']('scroller__sticky--fixed');
        $sticky[bottom ? 'addClass' : 'removeClass']('scroller__sticky--bottom');
      };

      const indicatorActiveClass = 'active';
      const imageActiveClass = 'scroller__image--active';

      const updateIndicatorsAndImages = ($indicators, $images, index) => {
        $indicators
          .children('li')
          .eq(index)
          .addClass(indicatorActiveClass)
          .siblings()
          .removeClass(indicatorActiveClass);

        $images.eq(index).addClass(imageActiveClass).siblings().removeClass(imageActiveClass);
      };

      $imageScrollers.each((index, element) => {
        const $section = $(element);
        const $content = $section.find('.section__content');
        const $blocks = $section.find('.scroller__block');
        const $sticky = $section.find('.scroller__sticky');
        const $indicators = $section.find('.scroller__indicators');
        const $images = $section.find('.scroller__image');

        new Waypoint({
          element: $content.get(0),
          handler(direction) {
            const fixed = direction === 'down';
            const bottom = false;

            updateSticky($sticky, fixed, bottom);
          },
        });

        new Waypoint({
          element: $content.get(0),
          handler(direction) {
            const fixed = direction === 'up';
            const bottom = !fixed;

            updateSticky($sticky, fixed, bottom);
          },
          offset: 'bottom-in-view',
        });

        $blocks.each((index, element) => {
          new Waypoint({
            element,
            handler(direction) {
              if (direction === 'down') {
                updateIndicatorsAndImages($indicators, $images, index);
              }
            },
            offset: '30%',
          });

          new Waypoint({
            element,
            handler(direction) {
              if (direction === 'up') {
                updateIndicatorsAndImages($indicators, $images, Math.max(0, index - 1));
              }
            },
            offset: '70%',
          });
        });

        $indicators.on('click', 'a', (e) => {
          const index = $(e.currentTarget).parent().index();

          $scrollable.animate(
            {
              scrollTop: $blocks.eq(index).offset().top + 'px',
            },
            400
          );
        });
      });
    }
  });
})(jQuery);
